// Generates a shareable "I POG'D IT!" story card (canvas) + native share.
const W = 1080, H = 1350;

function roundRect(ctx, x, y, w, h, r) {
  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.arcTo(x + w, y, x + w, y + h, r);
  ctx.arcTo(x + w, y + h, x, y + h, r);
  ctx.arcTo(x, y + h, x, y, r);
  ctx.arcTo(x, y, x + w, y, r);
  ctx.closePath();
}

function wrap(ctx, text, x, y, maxW, lh) {
  const words = String(text).split(" ");
  let line = "", yy = y;
  for (const w of words) {
    const test = line ? line + " " + w : w;
    if (ctx.measureText(test).width > maxW && line) {
      ctx.fillText(line, x, yy);
      line = w; yy += lh;
    } else line = test;
  }
  ctx.fillText(line, x, yy);
  return yy;
}

function loadImg(src) {
  return new Promise((res) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => res(img);
    img.onerror = () => res(null);
    img.src = src;
  });
}

export async function makePogShareCard({ businessName, dealTitle, discount, reward = 30 }) {
  const c = document.createElement("canvas");
  c.width = W; c.height = H;
  const ctx = c.getContext("2d");

  // Background
  const g = ctx.createLinearGradient(0, 0, 0, H);
  g.addColorStop(0, "#0f172a"); g.addColorStop(1, "#020617");
  ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);
  // glow blobs
  ctx.globalAlpha = 0.25;
  const rg = ctx.createRadialGradient(W / 2, 300, 40, W / 2, 300, 520);
  rg.addColorStop(0, "#22d3ee"); rg.addColorStop(1, "transparent");
  ctx.fillStyle = rg; ctx.fillRect(0, 0, W, 700);
  ctx.globalAlpha = 1;

  // Wordmark
  ctx.textAlign = "center";
  ctx.fillStyle = "#38bdf8";
  ctx.font = "900 52px Poppins, Arial, sans-serif";
  ctx.fillText("AIR.POG", W / 2, 110);
  ctx.fillStyle = "#64748b";
  ctx.font = "700 24px Poppins, Arial, sans-serif";
  ctx.fillText("ARTIFICIAL INTELLIGENCE RADAR", W / 2, 148);

  // Headline
  ctx.fillStyle = "#6ee7b7";
  ctx.font = "900 108px Poppins, Arial, sans-serif";
  ctx.fillText("I POG'D IT!", W / 2, 300);

  // Business name
  ctx.fillStyle = "#ffffff";
  ctx.font = "800 60px Poppins, Arial, sans-serif";
  wrap(ctx, businessName || "a local spot", W / 2, 400, W - 160, 68);

  // Deal card
  const cardX = 90, cardY = 470, cardW = W - 180, cardH = 260;
  ctx.save();
  ctx.shadowColor = "rgba(251,191,36,0.5)"; ctx.shadowBlur = 40;
  ctx.strokeStyle = "#fbbf24"; ctx.lineWidth = 5;
  ctx.fillStyle = "rgba(15,23,42,0.7)";
  roundRect(ctx, cardX, cardY, cardW, cardH, 36); ctx.fill(); ctx.stroke();
  ctx.restore();

  ctx.textAlign = "left";
  ctx.fillStyle = "#ffffff";
  ctx.font = "800 46px Poppins, Arial, sans-serif";
  wrap(ctx, dealTitle || "Exclusive deal", cardX + 44, cardY + 90, cardW - 88, 56);

  // Discount badge
  if (discount) {
    const bx = cardX + cardW - 70, by = cardY - 6;
    ctx.save();
    ctx.fillStyle = "#fbbf24";
    ctx.beginPath(); ctx.arc(bx, by, 78, 0, Math.PI * 2); ctx.fill();
    ctx.fillStyle = "#0f172a"; ctx.textAlign = "center";
    ctx.font = "900 40px Poppins, Arial, sans-serif";
    ctx.fillText(String(discount).split(" ")[0], bx, by + 6);
    ctx.font = "800 20px Poppins, Arial, sans-serif";
    ctx.fillText((String(discount).split(" ").slice(1).join(" ") || "DEAL").slice(0, 8), bx, by + 34);
    ctx.restore();
  }

  // +reward pill
  ctx.textAlign = "center";
  ctx.fillStyle = "rgba(251,191,36,0.14)";
  roundRect(ctx, W / 2 - 250, 790, 500, 96, 48); ctx.fill();
  ctx.fillStyle = "#fcd34d";
  ctx.font = "900 52px Poppins, Arial, sans-serif";
  ctx.fillText(`+${reward} POG BUCKZ`, W / 2, 855);

  // POGZILLA
  const zilla = await loadImg("/pogzilla.png");
  if (zilla) {
    const zw = 360, zh = 360;
    ctx.drawImage(zilla, W / 2 - zw / 2, 910, zw, zh);
  }

  // Footer
  ctx.fillStyle = "#94a3b8";
  ctx.font = "700 34px Poppins, Arial, sans-serif";
  ctx.fillText("Find live deals & collect POGZ", W / 2, 1300);
  ctx.fillStyle = "#38bdf8";
  ctx.font = "900 40px Poppins, Arial, sans-serif";
  ctx.fillText("airpog.com", W / 2, 1345);

  const dataUrl = c.toDataURL("image/png");
  const blob = await new Promise((res) => c.toBlob(res, "image/png"));
  return { blob, dataUrl };
}

export async function sharePogMoment({ businessName, dealTitle, discount, reward = 30 }) {
  const { blob, dataUrl } = await makePogShareCard({ businessName, dealTitle, discount, reward });
  const caption = `I'm POGGIN' at ${businessName || "a local spot"}! 🛹 Scored a deal on AIR.POG — find live deals + collect POGZ 👉 airpog.com`;
  const file = new File([blob], "airpog-pog-moment.png", { type: "image/png" });
  try {
    if (navigator.canShare && navigator.canShare({ files: [file] })) {
      await navigator.share({ files: [file], text: caption, title: "AIR.POG" });
      return "shared";
    }
    if (navigator.share) {
      await navigator.share({ text: caption, url: "https://airpog.com" });
      return "shared";
    }
  } catch (e) {
    if (e && e.name === "AbortError") return "aborted";
  }
  // Fallback: download the card + copy caption
  const a = document.createElement("a");
  a.href = dataUrl; a.download = "airpog-pog-moment.png"; a.click();
  try { await navigator.clipboard.writeText(caption); } catch { /* noop */ }
  return "downloaded";
}

export async function makeRankShareCard({ rank, bucks, stats = [], start, end }) {
  const c = document.createElement("canvas");
  c.width = W; c.height = H;
  const ctx = c.getContext("2d");

  const g = ctx.createLinearGradient(0, 0, 0, H);
  g.addColorStop(0, "#0f172a"); g.addColorStop(1, "#020617");
  ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);
  ctx.globalAlpha = 0.25;
  const rg = ctx.createRadialGradient(W / 2, 320, 40, W / 2, 320, 560);
  rg.addColorStop(0, "#a855f7"); rg.addColorStop(1, "transparent");
  ctx.fillStyle = rg; ctx.fillRect(0, 0, W, 760);
  ctx.globalAlpha = 1;

  // sprinkle stars
  ctx.fillStyle = "rgba(255,255,255,0.55)";
  for (let i = 0; i < 40; i++) {
    const x = (i * 173) % W, y = ((i * 89) % 500) + 40;
    ctx.fillRect(x, y, i % 3 === 0 ? 3 : 2, i % 3 === 0 ? 3 : 2);
  }

  ctx.textAlign = "center";
  ctx.fillStyle = "#38bdf8";
  ctx.font = "900 52px Poppins, Arial, sans-serif";
  ctx.fillText("AIR.POG", W / 2, 110);
  ctx.fillStyle = "#64748b";
  ctx.font = "700 24px Poppins, Arial, sans-serif";
  ctx.fillText("WEEKLY SKY REPORT 📡", W / 2, 150);
  if (start && end) {
    ctx.fillStyle = "#475569";
    ctx.font = "700 26px Poppins, Arial, sans-serif";
    ctx.fillText(`${start} → ${end}`, W / 2, 192);
  }

  ctx.fillStyle = "#e9d5ff";
  ctx.font = "800 40px Poppins, Arial, sans-serif";
  ctx.fillText("THIS WEEK I'M A", W / 2, 300);
  ctx.fillStyle = "#f0abfc";
  ctx.font = "900 92px Poppins, Arial, sans-serif";
  wrap(ctx, rank || "SKY ROOKIE 🐣", W / 2, 400, W - 120, 100);

  ctx.fillStyle = "rgba(251,191,36,0.14)";
  roundRect(ctx, W / 2 - 260, 520, 520, 96, 48); ctx.fill();
  ctx.fillStyle = "#fcd34d";
  ctx.font = "900 52px Poppins, Arial, sans-serif";
  ctx.fillText(`+${bucks || 0} POG BUCKS`, W / 2, 585);

  // stat grid 3x2
  const cols = 3, cw = 292, ch = 170, gx = (W - cols * cw - (cols - 1) * 24) / 2, gy = 680;
  stats.slice(0, 6).forEach((s, i) => {
    const x = gx + (i % cols) * (cw + 24), y = gy + Math.floor(i / cols) * (ch + 24);
    ctx.fillStyle = "rgba(30,41,59,0.85)";
    roundRect(ctx, x, y, cw, ch, 24); ctx.fill();
    ctx.strokeStyle = "rgba(100,116,139,0.4)"; ctx.lineWidth = 2; ctx.stroke();
    ctx.font = "48px Arial";
    ctx.fillText(s.emoji, x + cw / 2, y + 62);
    ctx.fillStyle = "#ffffff";
    ctx.font = "900 44px Poppins, Arial, sans-serif";
    ctx.fillText(String(s.value), x + cw / 2, y + 116);
    ctx.fillStyle = "#94a3b8";
    ctx.font = "700 19px Poppins, Arial, sans-serif";
    ctx.fillText(s.label.toUpperCase(), x + cw / 2, y + 150);
  });

  const zilla = await loadImg("/pogzilla.png");
  if (zilla) ctx.drawImage(zilla, W / 2 - 110, 1085, 220, 220);

  ctx.fillStyle = "#94a3b8";
  ctx.font = "700 32px Poppins, Arial, sans-serif";
  ctx.fillText("Tap balloons · catch stars · stack POG BUCKS", W / 2, 1298);
  ctx.fillStyle = "#38bdf8";
  ctx.font = "900 40px Poppins, Arial, sans-serif";
  ctx.fillText("airpog.com", W / 2, 1343);

  const dataUrl = c.toDataURL("image/png");
  const blob = await new Promise((res) => c.toBlob(res, "image/png"));
  return { blob, dataUrl };
}

export async function shareRankCard({ rank, bucks, stats, start, end }) {
  const { blob, dataUrl } = await makeRankShareCard({ rank, bucks, stats, start, end });
  const caption = `I'm a ${rank} on AIR.POG this week — +${bucks} POG BUCKS! 🎯 Catch me in the skies 👉 airpog.com`;
  const file = new File([blob], "airpog-sky-report.png", { type: "image/png" });
  try {
    if (navigator.canShare && navigator.canShare({ files: [file] })) {
      await navigator.share({ files: [file], text: caption, title: "My Weekly Sky Report 📡" });
      return "shared";
    }
    if (navigator.share) {
      await navigator.share({ text: caption, url: "https://airpog.com" });
      return "shared";
    }
  } catch (e) {
    if (e && e.name === "AbortError") return "aborted";
  }
  const a = document.createElement("a");
  a.href = dataUrl; a.download = "airpog-sky-report.png"; a.click();
  try { await navigator.clipboard.writeText(caption); } catch { /* noop */ }
  return "downloaded";
}

export async function makeSlamShareCard({ flips, title }) {
  const c = document.createElement("canvas");
  c.width = W; c.height = H;
  const ctx = c.getContext("2d");

  const g = ctx.createLinearGradient(0, 0, 0, H);
  g.addColorStop(0, "#1c0a02"); g.addColorStop(0.5, "#0f172a"); g.addColorStop(1, "#020617");
  ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);
  ctx.globalAlpha = 0.3;
  const rg = ctx.createRadialGradient(W / 2, 380, 60, W / 2, 380, 560);
  rg.addColorStop(0, "#f59e0b"); rg.addColorStop(1, "transparent");
  ctx.fillStyle = rg; ctx.fillRect(0, 0, W, 820);
  ctx.globalAlpha = 1;

  ctx.textAlign = "center";
  ctx.fillStyle = "#38bdf8";
  ctx.font = "900 52px Poppins, Arial, sans-serif";
  ctx.fillText("AIR.POG", W / 2, 110);
  ctx.fillStyle = "#64748b";
  ctx.font = "700 24px Poppins, Arial, sans-serif";
  ctx.fillText("SLAMMER SHOWDOWN 🥞", W / 2, 150);

  ctx.fillStyle = "#fbbf24";
  ctx.font = "900 96px Poppins, Arial, sans-serif";
  wrap(ctx, title || "POG'D IT!", W / 2, 300, W - 120, 104);

  // giant flips medallion
  ctx.save();
  ctx.shadowColor = "rgba(251,191,36,0.6)"; ctx.shadowBlur = 60;
  ctx.fillStyle = "#f59e0b";
  ctx.beginPath(); ctx.arc(W / 2, 620, 230, 0, Math.PI * 2); ctx.fill();
  ctx.restore();
  ctx.fillStyle = "#fde68a";
  ctx.beginPath(); ctx.arc(W / 2, 620, 205, 0, Math.PI * 2); ctx.fill();
  ctx.fillStyle = "#78350f";
  ctx.font = "900 150px Poppins, Arial, sans-serif";
  ctx.fillText(String(flips), W / 2, 660);
  ctx.font = "900 40px Poppins, Arial, sans-serif";
  ctx.fillText("CAPS FLIPPED", W / 2, 730);

  ctx.fillStyle = "rgba(251,191,36,0.14)";
  roundRect(ctx, W / 2 - 300, 900, 600, 90, 45); ctx.fill();
  ctx.fillStyle = "#fcd34d";
  ctx.font = "900 44px Poppins, Arial, sans-serif";
  ctx.fillText("CAN YOU BEAT MY SLAM?", W / 2, 960);

  const zilla = await loadImg("/pogzilla.png");
  if (zilla) ctx.drawImage(zilla, W / 2 - 110, 1030, 220, 220);

  ctx.fillStyle = "#94a3b8";
  ctx.font = "700 32px Poppins, Arial, sans-serif";
  ctx.fillText("Play the Slammer Showdown free", W / 2, 1295);
  ctx.fillStyle = "#38bdf8";
  ctx.font = "900 40px Poppins, Arial, sans-serif";
  ctx.fillText("airpog.com/slammer", W / 2, 1343);

  const dataUrl = c.toDataURL("image/png");
  const blob = await new Promise((res) => c.toBlob(res, "image/png"));
  return { blob, dataUrl };
}

export async function shareSlamCard({ flips, title }) {
  const { blob, dataUrl } = await makeSlamShareCard({ flips, title });
  const caption = `I flipped ${flips} caps in the AIR.POG Slammer Showdown! 🥞💥 Think you can beat me? 👉 airpog.com/slammer`;
  const file = new File([blob], "airpog-slam.png", { type: "image/png" });
  try {
    if (navigator.canShare && navigator.canShare({ files: [file] })) {
      await navigator.share({ files: [file], text: caption, title: "Slammer Showdown 🥞" });
      return "shared";
    }
    if (navigator.share) {
      await navigator.share({ text: caption, url: "https://airpog.com/slammer" });
      return "shared";
    }
  } catch (e) {
    if (e && e.name === "AbortError") return "aborted";
  }
  const a = document.createElement("a");
  a.href = dataUrl; a.download = "airpog-slam.png"; a.click();
  try { await navigator.clipboard.writeText(caption); } catch { /* noop */ }
  return "downloaded";
}
